import React, { useState } from "react";

const ConfettiOverlay = ({ isActive }) => {
  const [pieces] = useState(() =>
    Array.from({ length: 50 }, (_, i) => {
      const colors = ["#86efac", "#4ade80", "#a7f3d0", "#93c5fd", "#fcd34d", "#fca5a5", "#c4b5fd", "#f9a8d4"];
      const shapes = ["circle", "square", "triangle"];
      return {
        id: i,
        color: colors[Math.floor(Math.random() * colors.length)],
        shape: shapes[Math.floor(Math.random() * shapes.length)],
        left: Math.random() * 100,
        animationDelay: Math.random() * 1.5,
        animationDuration: 1.6 + Math.random() * 1.6,
        size: 4 + Math.random() * 8,
        randomX: `${(Math.random() - 0.5) * 200}px`,
      };
    })
  );
  if (!isActive) return null;
  return (
    <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
      {pieces.map((p) => (
        <div
          key={p.id}
          className={`absolute confetti-fall ${
            p.shape === "circle" ? "rounded-full" : p.shape === "triangle" ? "confetti-triangle" : ""
          }`}
          style={{
            left: `${p.left}%`,
            top: "-300px",
            width: `${p.size}px`,
            height: `${p.size}px`,
            backgroundColor: p.shape !== "triangle" ? p.color : "transparent",
            borderColor: p.shape === "triangle" ? p.color : "transparent",
            animationDelay: `${p.animationDelay}s`,
            animationDuration: `${p.animationDuration}s`,
            "--random-x": p.randomX,
          }}
        />
      ))}
      <style>{`
        @keyframes confetti-fall-kf {
          0% { transform: translateY(-200px) translateX(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(calc(100vh + 100px)) translateX(var(--random-x)) rotate(720deg); opacity: 0; }
        }
        .confetti-fall { animation: confetti-fall-kf linear infinite; }
        .confetti-triangle {
          width: 0; height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 12px solid;
        }
      `}</style>
    </div>
  );
};

export default ConfettiOverlay;
